// extracted by mini-css-extract-plugin
module.exports = {"score_interval_limit_wrapper":"ScoreIntervalLimit_score_interval_limit_wrapper__2rTey"};